import { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';

const navLinks = [
  { to: 'AboutMe',        label: 'About',          num: '01' },
  { to: 'Skills',         label: 'Skills',         num: '02' },
  { to: 'Projects',       label: 'Projects',       num: '03' },
  { to: 'Experience',     label: 'Experience',     num: '04' },
  { to: 'Education',      label: 'Education',      num: '05' },
  { to: 'Certifications', label: 'Certifications', num: '06' },
];

function Navbar() {
  const [menuOpen, setMenuOpen]   = useState(false);
  const [scrolled, setScrolled]   = useState(false);

  // Solid navbar once user scrolls past 60px
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Lock body scroll while mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="navbar-container">

        {/* Logo */}
        <Link
          to="AboutMe"
          smooth={true}
          offset={-70}
          className="navbar-logo"
          onClick={closeMenu}
        >
          KK<span className="logo-dot">.</span>
        </Link>

        {/* Desktop Nav */}
        <ul className="desktop-nav">
          {navLinks.map(({ to, label }) => (
            <li key={to} className="nav-item">
              <Link
                to={to}
                smooth={true}
                offset={-70}
                className="nav-links"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Hamburger (mobile only) */}
        <button
          className={`hamburger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen(prev => !prev)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
        </button>
      </div>

      {/* Full-screen mobile overlay */}
      <div className={`mobile-overlay${menuOpen ? ' open' : ''}`} aria-hidden={!menuOpen}>
        <ul className="mobile-nav-menu">
          {navLinks.map(({ to, label, num }) => (
            <li key={to} className="mobile-nav-item">
              <Link
                to={to}
                smooth={true}
                offset={-70}
                className="mobile-nav-link"
                onClick={closeMenu}
              >
                <span className="mobile-nav-num">{num}</span>
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;